/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { ErrorIcon, Errors as ErrorsStyled } from 'components';
import { formStore } from 'stores';

export default function Errors({ errors }) {
  return errors?.length > 0 ? (
    <ErrorsStyled.Errors>
      {errors.map((error, i) => (
        <ErrorsStyled.Error
          // eslint-disable-next-line react/no-array-index-key
          key={`${error.id}_${i}`}
          data-test={`error-${error.id}`}
          onClick={() => formStore.selectFormField(error.id)}
        >
          <ErrorsStyled.Element title={error.id} data-test="errorElement">
            <ErrorIcon category={error.category} />
            <ErrorsStyled.ElementId>{error.name || error.id}</ErrorsStyled.ElementId>
          </ErrorsStyled.Element>
          <ErrorsStyled.Message title={error.message}>{error.message}</ErrorsStyled.Message>
        </ErrorsStyled.Error>
      ))}
    </ErrorsStyled.Errors>
  ) : (
    <ErrorsStyled.EmptyState>
      <ErrorsStyled.SuccessIcon />
      <ErrorsStyled.EmptyStateMessage>No problems found.</ErrorsStyled.EmptyStateMessage>
    </ErrorsStyled.EmptyState>
  );
}
